// extracted by mini-css-extract-plugin
module.exports = {"main":"Notifications_main__2mcr0","box":"Notifications_box__1Ccef"};